import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Capture l'événement d'installation PWA au plus tôt (peut se déclencher avant le montage React)
window.__capexBip = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__capexBip = e;
  window.dispatchEvent(new Event('capex-bip-ready'));
});

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('[App] Service Worker registered:', registration.scope);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[App] New content available, refresh to update.');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.log('[App] Service Worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
